module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [(_vm.item) ? _c('h2', [_vm._v("Dane firmy/Edycja")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.retrieveLoading || _vm.updateLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.retrieveError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.retrieveError))]) : _vm._e(), _vm._v(" "), (_vm.updateError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.updateError))]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.retrieveLoading && !_vm.updateLoading) ? _c('CompanyForm', {
    attrs: {
      "handle-submit": _vm.update,
      "values": _vm.item,
      "errors": _vm.violations,
      "initialValues": _vm.retrieved
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d99f2446","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/Update.vue
// module id = 846
// module chunks = 0